// src/hooks/useBaseContext.js
import { createContext, useContext } from 'react';

/**
 * Creates a base context with standardized error handling
 * Reduces boilerplate code in context creation
 */
export const createBaseContext = (contextName) => {
  const Context = createContext();
  
  const useCustomContext = () => {
    const context = useContext(Context);
    if (!context) {
      throw new Error(`${contextName} must be used within a ${contextName}Provider`);
    }
    return context;
  };
  
  return { Context, useContext: useCustomContext };
};